import { render } from "./ResultStatCorrect.vue?vue&type=template&id=17765968&scoped=true"
import script from "./ResultStatCorrect.vue?vue&type=script&lang=js"
export * from "./ResultStatCorrect.vue?vue&type=script&lang=js"

import "@/css/components/c-result-stat-correct.css?vue&type=style&index=0&id=17765968&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17765968"]])

export default __exports__